import React from "react"
import cx from "classnames"

export interface TagProps {
  children: React.ReactNode
  className?: string
  variant?:
    | "muted"
    | "important"
    | "importantPrimary"
    | "success"
    | "successPrimary"
    | "info"
    | "accent"
    | "accentPrimary"
    | "connect"
    | "connectPrimary"
}

export const Tag = ({ children, variant, className }: TagProps) => (
  <div
    className={cx("cobalt-Tag", className, {
      [`cobalt-Tag--${variant}`]: variant,
    })}
  >
    {children}
  </div>
)
